import React from 'react';
import Hero12 from '../Hero/Hero12';
const heroSocialLinks = [
  {
    name: 'Instagram',
    links: 'https://www.instagram.com/justchargemedia/',
  },
  {
    name: 'Linkedin',
    links: 'https://www.linkedin.com/company/justchargemedia/posts/?feedView=all',
  },
];

const showcaseData = [
  {
    introTitle: 'Video Direction (Jan, 2023)',
    title: 'Nature video short',
    videoUrl: 'video/video-3.mp4',
    href: '/case-study/case-study-details',
  },
  {
    introTitle: 'Video Direction (Sep, 2023)',
    title: 'TV commercial ad',
    videoUrl: 'video/video-1.mp4',
    href: '/case-study/case-study-details',
  },
  {
    introTitle: 'Video Direction (Mar, 2023)',
    title: '3D world comes',
    videoUrl: 'video/video-2.mp4',
    href: '/case-study/case-study-details',
  },
];

export default function VideoShowcaseHome() {
  return (
    <>
      <Hero12
        heroSocialLinks={heroSocialLinks}
        socialLinksHeading="Follow Us"
        showcaseData={showcaseData}
      />
    </>
  );
}
